/* Imports */

import React, { useLayoutEffect } from "react";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import am5locales_fa_IR from "../../Assets/lang/fa_IR";

function CompareChart({ data, targetKeys, showItem }) {
  const detectItemType = (type) => {
    switch (type) {
      case "Ipv":
        return "Ipv";
      case "Vpv":
        return "Vpv";
      case "Vbat":
        return "Vbat";
      case "Vo":
        return "Vo";
      case "Ibat":
        return "Ibat";
      case "Pbat":
        return "Pbat";
      case "Ppv":
        return "Ppv";
      case "Pnet":
        return "Pnet";
      case "SOC":
        return "SOC";
      case "Temp":
        return "Temp";
    }
  };
  const detectItemUnit = (type) => {
    switch (type) {
      case "Ipv":
        return "A";
      case "Vpv":
        return "V";
      case "Vbat":
        return "V";
      case "Vo":
        return "V";
      case "Ibat":
        return "A";
      case "Pbat":
        return "W";
      case "Ppv":
        return "W";
      case "Pnet":
        return "W";
      case "SOC":
        return "%";
      case "Temp":
        return "ºC";
    }
  };
  // console.log(targetKeys, data);
  useLayoutEffect(() => {
    let root = am5.Root.new("CompareChart");

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);
    root.locale = am5locales_fa_IR;
    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        maxTooltipDistance: 0,
        pinchZoomX: true,
      })
    );

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    let xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        maxDeviation: 0.1,
        baseInterval: {
          timeUnit: "minute",
          count: 1,
        },
        renderer: am5xy.AxisRendererX.new(root, {}),
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    for (var i = 0; i < targetKeys.length; i++) {
      for (var j = 0; j < showItem.length; j++) {
        let yAxis = chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            renderer: am5xy.AxisRendererY.new(root, {
              ariaHidden: true,
            }),
          })
        );
        let pannelName = `${targetKeys[i].split("/")[1]}-${showItem[j]}`;
        let series = chart.series.push(
          am5xy.LineSeries.new(root, {
            name: pannelName,
            xAxis: xAxis,
            yAxis: chart.yAxes.getIndex(0),
            valueYField: detectItemType(showItem[j]),
            valueXField: "date",
            legendValueText: `{valueY} ${detectItemUnit(showItem[j])}`,
            tooltip: am5.Tooltip.new(root, {
              pointerOrientation: "horizontal",
              labelText: `{valueY} ${detectItemUnit(showItem[j])}`,
            }),
            minDistance: 3,
            connect: true,
          })
        );
        series.data.processor = am5.DataProcessor.new(root, {
          dateFormat: "yyyy-MM-dd",
          dateFields: ["date"],
        });
        if (data[i]) {
          // date = new Date();
          // date.setHours(0, 0, 0, 0);
          // value = 0;
          let rev_data = data[i];
          //   let data = generateDatas(100);
          // console.log(rev_data, "is data");
          series.data.setAll(rev_data);
          // Make stuff animate on load
          // https://www.amcharts.com/docs/v5/concepts/animations/
          series.appear();
        }
      }
    }

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    let cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        behavior: "none",
      })
    );
    cursor.lineY.set("visible", false);

    // Add scrollbar
    // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
    chart.set(
      "scrollbarX",
      am5.Scrollbar.new(root, {
        orientation: "horizontal",
      })
    );

    chart.set(
      "scrollbarY",
      am5.Scrollbar.new(root, {
        orientation: "vertical",
      })
    );

    // Add legend
    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
    let legend = chart.rightAxesContainer.children.push(
      am5.Legend.new(root, {
        width: 200,
        paddingLeft: 15,
        // paddingBottom: 20,
        height: am5.percent(100),

      })
    );

    // When legend item container is hovered, dim all the series except the hovered one
    legend.itemContainers.template.events.on("pointerover", function (e) {
      let itemContainer = e.target;

      // As series list is data of a legend, dataContext is series
      let series = itemContainer.dataItem.dataContext;

      chart.series.each(function (chartSeries) {
        if (chartSeries != series) {
          chartSeries.strokes.template.setAll({
            strokeOpacity: 0.15,
            stroke: am5.color(0x000000),
          });
        } else {
          chartSeries.strokes.template.setAll({
            strokeWidth: 3,
          });
        }
      });
    });

    // When legend item container is unhovered, make all series as they are
    legend.itemContainers.template.events.on("pointerout", function (e) {
      let itemContainer = e.target;
      let series = itemContainer.dataItem.dataContext;

      chart.series.each(function (chartSeries) {
        chartSeries.strokes.template.setAll({
          strokeOpacity: 1,
          strokeWidth: 1,
          stroke: chartSeries.get("fill"),
        });
      });
    });

    legend.itemContainers.template.set("width", am5.p100);
    legend.valueLabels.template.setAll({
      width: am5.p100,
      textAlign: "right",
    });

    // It's is important to set legend data after all the events are set on template, otherwise events won't be copied
    legend.data.setAll(chart.series.values);

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(1000, 100);

    return () => root.dispose();
  });

  return (
    <div
      id="CompareChart"
      style={{ minWidth: "600px", height: "500px", direction: "ltr",width:"100%" }}
    ></div>
  );
}
export default React.memo(CompareChart);
